export const FilterCategoryCard = ({ category, isSelected, onToggle }) => {
  return (
    <div
      key={category.id}
      className={`px-2 py-2 rounded-lg cursor-pointer border ${
        isSelected ? 'bg-[#2F80ED] text-white border-[#2F80ED]' : 'bg-gray-50 border-gray-200'
      } md:px-4 md:py-2 px-2 py-1`}
      onClick={onToggle}
    >
      <div className='flex items-center gap-2'>
        {category.src && <img src={category.src} alt={category.name} className="md:w-[28px] md:h-[28px] w-6 h-6" />}
        <span className="md:text-base text-sm">{category.name}</span>
      </div>
    </div>
  );
};
